import axios from "../config/axios"


export const UserRepository = {
  getAll: () => {
    return axios.get(`/api/user/all`);
  },
  updateStatus: (username, enabled) => {
    return axios.patch(`/api/user/${username}`, {enabled});
  },
  updateRoles: (username, roles) => {
    return axios.post(`/api/user/${username}/roles`, {roles});
  },
  delete: (username) => {
    return axios.delete(`/api/user/${username}`);
  },
}
